import React, { Component } from 'react';
import moment from 'moment';
import cx from 'classnames';
import _ from "lodash";
import utils from '../../../lib/utils';
import './index.scss';

//import { GetAppointmentTimeSlot } from '../../network';

const no_of_days = 7;

function create_UUID(){
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (dt + Math.random()*16)%16 | 0;
        dt = Math.floor(dt/16);
        return (c=='x' ? r :(r&0x3|0x8)).toString(16);
    });
    return uuid;
}


class TimeSlot extends Component{
    constructor(props){
        super(props);
        this.state = {
            initDate:new Date(),
            no_of_days:7,
            header:this.getHeaderDays(new Date(),7),
            loading:true,
            availability:[],
            schedule: {
                appointments: [],
                staff_schedule: []
            },
            parsedAvailability:[],
            selected_service:'',
            selected_staff:'',
            selected_resource:''
        };
    }

    componentDidMount(){        
        this.fetchAvailability({
            start_date : moment().format('YYYY-MM-DD'),
            start_time:moment().format('HH:mm:ss'), 
            end_date : moment().add(no_of_days,'days').format('YYYY-MM-DD'), 
            end_time:"23:59:59" 
        });
    }

    componentWillReceiveProps(nextProps){
        if(nextProps?.schedules?.availability!== this.props?.schedules?.availability){
            this.setState({
                availability : nextProps?.schedules?.availability,
                schedule: nextProps?.schedules?.schedule,
            })
        }
    }
    
    componentDidUpdate(prevProps, prevState) {
        if(this.state.availability != prevState.availability) {
            this.getDateRangeArray();
        }
        if(prevProps.selected_service !== this.props.selected_service 
            || prevProps.selected_staff !== this.props.selected_staff 
            || prevProps.selected_resource !== this.props.selected_resource
        ){
            this.onFilterUpdate();
        }
    }
    
    onFilterUpdate=()=>{
        const { initDate } = this.state;
        this.fetchAvailability({
            start_date : moment(initDate).format('YYYY-MM-DD'),
            start_time:moment().format('HH:mm:ss'), 
            end_date : moment(initDate).add(no_of_days,'days').format('YYYY-MM-DD'), 
            end_time:"23:59:59" 
        });
    }

    getHeaderDays = (date,no_of_days) =>{
        let headerDays= [],i;
        for(i=0;i<no_of_days;i++){
            headerDays.push(moment(date).add(i,'days').startOf('day'));
        } 
    return headerDays;
    }

    getDateRangeArray = () =>{
        const { availability, schedule } = this.state;
        const { business_working_hours } = this.props;
        const blockedSlot = schedule?.staff_schedule?.filter(slot=>!slot.isAvailable);
        const result = availability?.availability_groups || [];
        let daterange1 = [];
        for(let j=0;j<result.length;j++){
             result[j].slots.map(dayslot=>{
                const { slot,date }  = dayslot.slot;
                const {start, end} = slot;
                const datetime = date+''+start; 
                
                let range = { blocked:false, start:start, end: end,date:date,id:result[j].id , slotid: moment(datetime,'YYYY-MM-DD HH:mm:ss').valueOf()}
                daterange1.push(range);
            });
        }
        console.log('blockedSlot',blockedSlot);
        for(let i=0;i<blockedSlot.length;i++){
            blockedSlot[i].slots.map(dayslot=>{
               const {start, end} = dayslot;
               const date = blockedSlot[i].date;
               const datetime = date+''+start; 
               const isAvailable = !(blockedSlot[i]?.isAvailable === false);
               let diff = moment.duration(moment(end,'HH:mm:ss').diff(moment(start,'HH:mm:ss'))).asMinutes();
               console.log('SLOT LOG 1', moment(start,'HH:mm:ss').hour() , moment(end,'HH:mm:ss').hour());
                if(moment(start,'HH:mm:ss').hour()!==moment(end,'HH:mm:ss').hour()){
                    let time_start = start;
                    let title_display = true;
                    do{
                        let time_diff =  diff > 59 ? 60 - moment(time_start,'HH:mm:ss').minutes(): diff;
                         let range = { slotdata: blockedSlot[i],time_diff ,...(!!isAvailable && {title: blockedSlot[i]?.sections[0]?.user_name}), title_display ,blocked:!isAvailable ,start:time_start, end: moment(time_start,'HH:mm:ss').add(time_diff-1,'minutes').format('HH:mm:ss'),date:date, id: create_UUID() , slotid: moment(datetime,'YYYY-MM-DD HH:mm:ss').valueOf()}
                         time_start = moment(range.end,'HH:mm:ss').add(1,'minutes').format('HH:mm:ss');
                         daterange1.push(range);
                         diff = diff - time_diff;
                         title_display = false;
                    }while(diff>0)
                }else{
                    let range = { slotdata: blockedSlot[i], time_diff:diff, ...(!!isAvailable && {title: blockedSlot[i]?.sections[0]?.user_name}),title_display:true, blocked:!isAvailable, start:start, end: end,date:date, id: create_UUID() , slotid: moment(datetime,'YYYY-MM-DD HH:mm:ss').valueOf()}
                     daterange1.push(range);
                }
           });
       }
        
        daterange1 = _.uniqBy(daterange1, 'id');
        console.log('SLOT LOG 2', daterange1, daterange1.filter(slot=>slot.blocked));
        let headerDays = this.getHeaderDays(moment(this.state.initDate,'YYYY-MM-DD'),no_of_days);
        let slotSchedule =[]
        for(let i=0;i<business_working_hours.length;i++){
            slotSchedule[i] =[];
            for(let j=0;j<headerDays.length;j++){
                slotSchedule[i][j] = daterange1.filter(slot=>moment(slot.date,'YYYY-MM-DD').isSame(headerDays[j]) && moment(slot.start,'HH:mm:ss').isBetween(moment(business_working_hours[i].start,'HH:mm:ss'),moment(business_working_hours[i].end,'HH:mm:ss')));
            }

        }
        console.log('twoDarray',slotSchedule);
        
        let groupedResults = _.groupBy(daterange1, (result) => moment(result['date'], 'YYYY-MM-DD').startOf('isoDay'));
              
        let slot = sessionStorage.getItem('slot');
        const { initDate } = this.state;
        let initialDate = initDate;
        let first_result = (Object.keys(groupedResults)[0])?new Date(Object.keys(groupedResults)[0]):initDate;
        if(moment(first_result).diff(initDate,'days')>no_of_days-1){
            initialDate = new Date(Object.keys(groupedResults)[0]);
        }
  
        this.setState({
            header:Object.keys(groupedResults).slice(0, no_of_days),
            loading:false,
            initDate: initialDate,
            parsedAvailability: slotSchedule
        })
    }

    fetchAvailability =(time_span)=>{
        const { business, selected_service, selected_staff, selected_resource,location_id } = this.props;
        let requestData = {};
        requestData.business_id = business.id;
        requestData.service_id = selected_service;
        requestData.staff_ids = typeof selected_staff === "object"? selected_staff:[selected_staff];
        requestData.location_id = location_id;
        requestData.resource_ids= typeof selected_resource === "object"? selected_resource:[selected_resource];
        requestData.time_span = time_span;
        this.setState({initDate: time_span.start_date, loading:true});
        this.props.getDentalSchedules(requestData);
    }

    loadNext = () =>{
        const header  = this.validateHeader(this.state.header);
        this.fetchAvailability({
            start_date : moment(header[header.length-1]).add(1,'days').format('YYYY-MM-DD'),
            start_time:"00:00:00", 
            end_date : moment(header[header.length-1]).add(no_of_days+2,'days').format('YYYY-MM-DD'), 
            end_time:"23:59:59" 
        });
    }

    loadPrev = () =>{
        const header  = this.validateHeader(this.state.header);
        let start = moment().isBefore(header[0])?moment(header[0]):moment();
        this.fetchAvailability(
            {
            start_date: start.subtract(no_of_days,'days').format('YYYY-MM-DD'), 
            start_time: moment().isBefore(start.subtract(no_of_days,'days'))?'00:00:00':moment().format('HH:mm:ss'),
            end_date: moment(header[0]).format('YYYY-MM-DD'),
            end_time:"23:59:59", 
        });
    }

    jumpToToday = () =>{
        this.fetchAvailability({
            start_date : moment().format('YYYY-MM-DD'),
            start_time:"00:00:00", 
            end_date : moment().add(no_of_days+2,'days').format('YYYY-MM-DD'), 
            end_time:"23:59:59" 
        });
    }
    
    validateHeader=(header)=>{
        const { initDate } = this.state;
        let headerDays = this.getHeaderDays(moment(initDate,'YYYY-MM-DD'),no_of_days);
        return headerDays.slice(0, no_of_days);
    }
    getBlockHeight=(diff)=>{
        console.log('SLOT LOG 3', Math.round((diff/60)*100).toString()+'%'); 
        return Math.round((diff/60)*100).toString()+'%';
    }
    getAlignment=(time)=>{
        const minute = moment(time,'HH:mm:ss').minutes();
        if(minute>29){
            return 'flex-end';
        }else{
            return 'flex-start';
        }
    }
    getPositioning=(row, slotData)=>{
        let size = 0;
        for(let i=0;i<row.length;i++){
            size = (row[i].length>size)? row[i].length:size
        }
        if(slotData.length>0){
         return (slotData.length<size && moment(slotData[0]?.start,'HH:mm:ss').minutes()>0) ? 'flex-end':'flex-start';
        }
       
    }
    loadNextAvailable = () =>{
        const header  = this.validateHeader(this.state.header);
        const { availability } = this.state;
        const { next_available_dates } = availability;
        if( next_available_dates !== null){
            this.fetchAvailability(
                {
                start_date : moment(next_available_dates).add(1,'days').format('YYYY-MM-DD'),
                start_time:"00:00:00", 
                end_date : moment(next_available_dates).add(no_of_days+2,'days').format('YYYY-MM-DD'), 
                end_time:"23:59:59" 
            });
        }else{
        this.fetchAvailability(
            {
                start_date : moment(header[header.length-1]).add(1,'days').format('YYYY-MM-DD'),
                start_time:"00:00:00", 
                end_date : moment(header[header.length-1]).add(no_of_days+2,'days').format('YYYY-MM-DD'), 
                end_time:"23:59:59" 
            });
        }
    }

    render(){
        const {header,loading,availability,  parsedAvailability} = this.state;
        const displayheader = this.validateHeader(header);
        console.log('parsedAvailability',parsedAvailability, availability)
        return(<>
            <div className="timeslot">
            <table className={cx('slot-table', {'loading': loading})}>
            {loading && <div className="loader"></div>}
            {!loading && availability?.availability_groups?.length===0 && <div className="nextavailablebutton" onClick={this.loadNextAvailable}><div className="innter-container"><span className="calender-icon"><i className="material-icons">calendar_month</i></span>JUMP TO NEXT AVAILABLE</div></div>}
                <thead  className="slot-header" >
                    <tr>
                    <th>
                    <button className={cx('slot-header__header',{'disabled': moment().startOf('day').isSame(displayheader[0])} )} onClick={this.loadPrev} disabled={moment().startOf('day').isSame(displayheader[0])}>
                        <div><i className="material-icons">chevron_left</i></div>
                    </button>
                    </th>
                        {displayheader && displayheader.map((date,index)=>{
                        return<th key={date} className={`header-${index}`}>
                                <div className="slot-header__header">
                                    {moment().startOf('day').diff(moment(date).startOf('day'),'days')===0 &&<div className="dot">.</div>}
                                    <div className="day_of_week">   
                                        {moment(date).format('ddd')}
                                    </div>
                                    <div className="day_of_month">   
                                        {moment(date).format('MMM DD')}
                                    </div>
                                </div>
                              </th>
                        })}
                    <th>
                    <button className="slot-header__header" onClick={this.loadNext}>
                        <div><i className="material-icons">chevron_right</i></div>
                    </button>
                    </th>
                        </tr>
                </thead>
               
                <tbody className="slot-body">
                {parsedAvailability.map((slots,index)=>{
                    return (<tr className="slot-body__row">
                         <td className="slot-body__row__data slot-label">
                             <div className="slot-body__row__data_timeslots">{this.props.business_working_hours[index].label}</div>
                         </td>
                        {slots.map(slotofDay=>{
                            return (<td className="slot-body__row__data">
                                <div className="slot-body__row__data_period" style={{justifyContent:this.getPositioning(slots,slotofDay)}}>
                                {slotofDay.map(slot=>{
                                   return <>{slot.blocked?<div style={{height:this.getBlockHeight(slot.time_diff), justifySelf:this.getAlignment(slot.start), width:'100%' }}><div  className="blocked" >{slot.title_display? moment(slot.start,'HH:mm:ss').format('hh:mm')+ ' Blocked scheduling': ''}</div></div>:<div style={{justifySelf:this.getAlignment(slot.start) , width:'100%'}}><div  className="slot" >{moment(slot.start,'HH:mm:ss').format('hh:mm')}</div></div>}</>
                                })}
                                </div>
                             </td>)
                        })}
                     <td className="slot-body__row__data"></td>
                    </tr>)
                })}
                </tbody>
            </table>
            </div>
             </>
        )
    }
}

export default TimeSlot;